const slideYoutubeAll = document.querySelectorAll(".splide__slide-youtube");
if (slideYoutubeAll) {
  slideYoutubeAll.forEach(slideYt => {
    console.log('slideYt', slideYt)
    const previewImage = slideYt.querySelector(".mm-video-preview");
    const iframe = slideYt.querySelector('iframe');
    if (window.innerWidth < 768) {
      const youtubeMobileID = slideYt.dataset.mobile;
      if (youtubeMobileID) {
        let srcMobile = `https://www.youtube.com/embed/${youtubeMobileID}?mute=1`;
        console.log('srcmobile', srcMobile)
        iframe.src = srcMobile;
        console.log("iframe.src", iframe.src);

      }
    }
    if (previewImage) {
      previewImage.addEventListener("click", () => {
        let videoSrc = iframe.src;
        // Vérifie si autoplay=1 est déjà présent
        if (!videoSrc.includes("autoplay=1")) {
          // Ajoute autoplay=1
          const separator = videoSrc.includes("?") ? "&" : "?";
          videoSrc += `${separator}autoplay=1`;
        }
        iframe.src = videoSrc;
        previewImage.style.display = "none"; // Cache l'image
		  });
	  }
  });
}
